import React from 'react';
import { Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

interface ReadOnlyFieldProps {
  label: string;
  value: string | number | undefined;
  className?: string;
}

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = ({
  label,
  value,
  className = 'col-6',
}) => (
  <div className={className}>
    <label className="form-label">{label}</label>
    <input className="form-control" value={value || ''} disabled readOnly />
  </div>
);

interface ApprovalNamePositionFieldsProps {
  nameFieldName: string;
  positionFieldName: string;
  disabled?: boolean;
}

export const ApprovalNamePositionFields: React.FC<
  ApprovalNamePositionFieldsProps
> = ({ nameFieldName, positionFieldName, disabled = true }) => {
  const { register, watch } = useFormContext();

  return (
    <Row>
      <div className="col-6">
        <label className="form-label">Name</label>
        <input
          className="form-control"
          {...register(nameFieldName)}
          value={watch(nameFieldName) || ''}
          disabled={disabled}
          readOnly
        />
      </div>
      <div className="col-6">
        <label className="form-label">Position</label>
        <input
          className="form-control"
          {...register(positionFieldName)}
          value={watch(positionFieldName) || ''}
          disabled={disabled}
          readOnly
        />
      </div>
    </Row>
  );
};
